import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ReactComponent as CloseIcon } from 'assets/close-icon.svg';
import { MAX_NEW_LIMIT_GROUP_NAME_LENGTH } from 'components/constants';
import i18nContext from 'components/i18n-context';
import { hasRole, LIMIT_GROUPS_UPDATE } from 'services/roles';
import Button from 'uikit/Button/Button';
import Input from 'uikit/Input/Input';
import './PopUpRenameLimitGroupScheme.scss';

const PopUpRenameLimitGroupScheme = ({ isLoading, limitGroupId, handleClose, handleRenameLimitGroup }) => {
  const i18n = useContext(i18nContext);

  const form = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      newLimitGroupName: limitGroupId
    },
    validationSchema: Yup.object().shape({
      newLimitGroupName: Yup.string()
        .required(i18n.getMessage('renameLimitGroup.modal.validation.isRequired'))
        .max(
          MAX_NEW_LIMIT_GROUP_NAME_LENGTH,
          i18n.getMessage('renameLimitGroup.modal.validation.maxSize"', { size: MAX_NEW_LIMIT_GROUP_NAME_LENGTH })
        )
    }),
    onSubmit: async (values) => {
      await handleRenameLimitGroup(limitGroupId, { limitGroupId: values.newLimitGroupName });
    }
  });

  const { values, handleSubmit, errors, handleChange } = form;

  return (
    <div className={'scheme-wrapper scheme-rename-limit-group-container'}>
      <div className={'scheme-rename-limit-group-container-header'}>
        <h3>{i18n.getMessage('renameLimitGroup.modal.title')}</h3>
        <CloseIcon className={'scheme-rename-limit-group-container-header-close-icon'} onClick={handleClose} />
      </div>
      <form className={'scheme-rename-limit-group-form'} onSubmit={handleSubmit}>
        <div className={'scheme-rename-limit-group-form-inputs-wrapper'}>
          <Input
            className={'scheme-rename-limit-group-input'}
            id={'newLimitGroupName'}
            name={'newLimitGroupName'}
            label={i18n.getMessage('renameLimitGroup.modal.input.newLimitGroupName')}
            value={values.newLimitGroupName}
            onChange={handleChange}
            max={MAX_NEW_LIMIT_GROUP_NAME_LENGTH}
            isDisabled={!hasRole(LIMIT_GROUPS_UPDATE)}
            error={errors?.newLimitGroupName}
          />
        </div>

        <div className={'scheme-rename-limit-group-actions-wrapper'}>
          <Button
            className={'scheme-rename-limit-group-button'}
            type={'outline'}
            onClick={handleClose}
            isDisabled={isLoading}
          >
            {i18n.getMessage('renameLimitGroup.modal.button.cancel')}
          </Button>
          <Button
            className={'scheme-rename-limit-group-button'}
            roleType={'submit'}
            type={'primary'}
            isDisabled={isLoading}
          >
            {i18n.getMessage('renameLimitGroup.modal.button.rename')}
          </Button>
        </div>
      </form>
    </div>
  );
};

PopUpRenameLimitGroupScheme.propTypes = {
  isLoading: PropTypes.bool,
  limitGroupId: PropTypes.string,
  handleClose: PropTypes.func,
  handleRenameLimitGroup: PropTypes.func
};

export default PopUpRenameLimitGroupScheme;
